import React, { Fragment } from "react";

import {RadioItems} from "../global";

import "./RadioItem.scss";

const RadioItem = ({surah}) => {



    return (
        <section className="surahs">            
            {surah !== null && (
                <Fragment>

                    {/* start title  */}
                    <div className="title">
                        <h5 className="title-text">{surah.Name}</h5>
                    </div>
                    

                    {/* start audio list  */}
                    <div className="audio-list">
                        <div className="row radio">
                            {
                                surah.data.map((item, index) => (
                                   
                                    <RadioItems 
                                        key={index}
                                        index={index}
                                        surahData={item}
                                        name={item.Name}
                                        rewaya={item.URL}
                                        uid={index} />
                                ))
                            }
                        </div>
                    </div>

                </Fragment>
            )}
        </section>
    )


    

}

// const Replace = (url) => {
   

//     return  url.replace("http://","https://")
    
// }


export default RadioItem;